import { render } from "./SelecionarBanco.vue?vue&type=template&id=9842d5f4&scoped=true&ts=true"
import script from "./SelecionarBanco.vue?vue&type=script&lang=ts"
export * from "./SelecionarBanco.vue?vue&type=script&lang=ts"

import "./SelecionarBanco.vue?vue&type=style&index=0&id=9842d5f4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9842d5f4"]])

export default __exports__